<template>
  <div class="profile-videos__empty-state">
    <div class="d-flex flex-column justify-content-center">
      <VsEmptyState
        :icon="options.icon"
        :name="options.name"
        :src="options.src"
        :title="options.title"
        :message="options.message"
      />
      <slot />
    </div>
  </div>
</template>

<script>
import VsEmptyState from '@/scripts/Components/Organisms/VsEmptyState';

const initialMessages = I18n.t('profile.empty_state.default_messages');

export default {
  components: {
    VsEmptyState,
  },
  props: {
    options: {
      type: Object,
      default: () => ({
        name: 'no-watch-later',
        title: initialMessages[(Math.random() * initialMessages.length) | 0],
      }),
    },
  },
};
</script>

<style lang="scss" scoped>
.profile-videos__empty-state {
  min-height: 480px;
  margin-top: 104px;
  // Do fade animation
  opacity: 1;
  animation: fadein 0.5s;
}

@keyframes fadein {
  from { opacity: 0; }
  to   { opacity: 1; }
}
</style>
